module.exports = __webpack_public_path__ + "ec6420b9a6d4a1fab43fb1e7b5002c72.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/176.png
// module id = 1763
// module chunks = 2